import { bootstrap } from './liteReferralBootstrap';

bootstrap();
